import { request } from '../request';

export async function deleteSingleShiftTypePreset(id: string) {
  return request.delete<void>(`/v2/templates/time-presets/${id}`);
}
